import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Text from 'components/Text/Text';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	EditRestaurantContext,
	IEditRestaurantContext,
} from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import React, { useContext } from 'react';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import { ILocalizationContext, LocalizationContext } from '../../../../localizationState/localizationContext';
import { getRestaurantLocalizationInfo } from 'backend/restaurants';
import style from './CustomerSettingsCheckbox.module.scss';

const CustomerSettingsCheckbox: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { IDSelectedCustomer, restaurantId } = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const { toggleUseCustomerSettings, updateGroups, useCustomerSettings } =
		useContext<ILocalizationContext>(LocalizationContext);

	const checkBoxClasses = classNames(style.checkBox, { [style.active]: useCustomerSettings });

	const handleChange = async (e: CheckboxChangeEvent) => {
		toggleUseCustomerSettings();
		showLoader();
		const response = await getRestaurantLocalizationInfo({
			customerID: IDSelectedCustomer || '',
			restaurantID: restaurantId,
			useCustomerSettings: e.target.checked,
		});
		updateGroups(response.data.groups);
		hideLoader();
	};

	return (
		<div className={style.container} data-test="CustomerSettingsCheckbox">
			<Text
				className={style.heading}
				translationNameSpace="localizationSettings"
				translationKey="customerSettingsLabel"
				theme="secondary"
				size="l"
				weight="bold"
			/>
			<Checkbox className={checkBoxClasses} checked={useCustomerSettings} onChange={handleChange}>
				<Text
					translationNameSpace="localizationSettings"
					translationKey="useCustomerSettingsLabel"
					asFragment={true}
				/>
			</Checkbox>
		</div>
	);
};

export default CustomerSettingsCheckbox;
